/* ppa-shims.js — safe globals used by theme scripts (finalized) */
(function () {
  // --- debounce ---
  if (typeof window.debounce !== 'function') {
    window.debounce = function (fn, wait) {
      var t;
      return function () {
        var ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    };
  }

  // --- throttle ---
  if (typeof window.throttle !== 'function') {
    window.throttle = function (fn, limit) {
      var inThrottle, lastArgs, timer;
      return function () {
        var ctx = this, args = arguments;
        if (!inThrottle) {
          fn.apply(ctx, args);
          inThrottle = true;
          timer = setTimeout(function () {
            inThrottle = false;
            if (lastArgs) {
              fn.apply(ctx, lastArgs);
              lastArgs = null;
            }
          }, limit);
        } else {
          lastArgs = args;
        }
      };
    };
  }

  // --- timing constants ---
  if (typeof window.ON_CHANGE_DEBOUNCE_TIMER === 'undefined') window.ON_CHANGE_DEBOUNCE_TIMER = 300;
  if (typeof window.ON_INPUT_DEBOUNCE_TIMER === 'undefined') window.ON_INPUT_DEBOUNCE_TIMER = 150;
  if (typeof window.CART_REFRESH_DEBOUNCE_TIMER === 'undefined') window.CART_REFRESH_DEBOUNCE_TIMER = 200;

  // --- simple pub/sub bus ---
  if (typeof window.__PPA_EVENT_BUS__ === 'undefined') {
    const bus = {};
    window.subscribe = function (event, callback) {
      if (!bus[event]) bus[event] = [];
      bus[event].push(callback);
      return function unsubscribe() {
        bus[event] = bus[event].filter(cb => cb !== callback);
      };
    };
    window.publish = function (event, data) {
      if (!bus[event]) return;
      bus[event].forEach(cb => {
        try { cb(data); } catch (e) { console.error('[PPA subscribe callback]', e); }
      });
    };
    window.unsubscribe = function (event, callback) {
      if (!bus[event]) return;
      bus[event] = bus[event].filter(cb => cb !== callback);
    };
    window.__PPA_EVENT_BUS__ = bus;
  }

  // --- PUB_SUB_EVENTS mapping ---
  if (typeof window.PUB_SUB_EVENTS === 'undefined') {
    window.PUB_SUB_EVENTS = {
      cartUpdate: 'cart-update',
      cartError: 'cart-error',
      quantityUpdate: 'quantity-update',
      cartDrawerOpen: 'cart-drawer-open',
      cartDrawerClose: 'cart-drawer-close',
      sectionLoad: 'shopify:section:load',
      cartRefresh: 'cart:refresh',
      cartUpdated: 'cart:updated'
    };
  }

})();
